import Vue from 'vue'
import { SnapSlider, SnapSliderSlide } from '@/components/shared/atoms/SnapSlider'

export default () => {
  Vue.component('SnapSlider', SnapSlider)
  Vue.component('SnapSliderSlide', SnapSliderSlide)
}
